import QuickStartGuidePage from '../../mdx/api/quick-start-guide.mdx'
import ResponsePage from '../../mdx/api/response-codes.mdx'
import EndpointsPage from '../../components/endpoints-page'
import SchemaPage from '../../components/schema'
import DividerLine from '../shared/divider-line'
import Anchor from '../anchor'
import React, { Fragment } from 'react'
import DocsPageGlobalStyles from '../../styles/docs-page'
import SectionHeader from '../../mdx/sdk/section-header.mdx'

const DocsSection = ({ children, anchorId, pathname, dividerLine = true }) => {
    return (
        <section>
            {dividerLine ? <DividerLine /> : ''}
            <Anchor pathname={pathname} id={anchorId} />
            {children}
        </section>
    )
}

const Api = () => {
    return (
        <Fragment>
            <DocsPageGlobalStyles />
            <div>
                <SectionHeader />
                <DocsSection pathname="/docs/api" anchorId="quick-start-guide">
                    <QuickStartGuidePage />
                </DocsSection>
                <DocsSection anchorId="endpoint">
                    <EndpointsPage />
                </DocsSection>
                <DocsSection anchorId="schema">
                    <SchemaPage />
                </DocsSection>
                <DocsSection pathname="/docs/api" anchorId="response-codes">
                    <ResponsePage />
                </DocsSection>
            </div>
        </Fragment>
    )
}

export default Api
